import * as React from 'react';

type BackendFetch = (path: string, init?: RequestInit) => Promise<Response>;

const BackendFetchContext = React.createContext<BackendFetch | undefined>(undefined);

export const BackendFetchContextProvider = BackendFetchContext.Provider;

export const useBackendApiFetch = (): BackendFetch => {
  const fn = React.useContext(BackendFetchContext);
  if(!fn) throw new Error('useBackendApiFetch must be used within a BackendFetchContextProvider');
  return fn;
};
